const DIAGRAM_KEY_CONTROLS_IDS = {
  CardiometabolicAppetiteControlDiagramKey: "appetite-control-key",
  CardiometabolicCircadianRhythmDiagramKey: "circadian-rhythm-key",
  CardiometabolicFatMetabolismDiagramKey: "cardiometabolic-fat-metabolism-key",
  CardiometabolicInflammationDiagramKey: "cardiometabolic-inflammation-key",
  CardiometabolicNitricOxideDiagramKey: "cardiometabolic-nitric-oxide-key",
  CardiometabolicOmega3DiagramKey: "cardiometabolic-omega3-key",
  CardiometabolicOverviewDiagramKey: "cardiometabolic-overview-key",
  CardiometabolicSodiumPotassiumDiagramKey: "cardiometabolic-sodium-potassium-key",
  CardiometabolicSugarMetabolismDiagramKey: "cardiometabolic-sugar-metabolism-key",
  EndocrineAndrogensDiagramKey: "endocrine-androgens-key",
  EndocrineOestrogenDiagramKey: "endocrine-oestrogen-key",
  EndocrineOverviewDiagramKey: "endocrine-overview-key",
  EndocrineProgesteroneDiagramKey: "endocrine-progesterone-key",
  EndocrineStressCortisolCortisoneDiagramKey: "endocrine-stress-cortisol-cortisone-key",
  EndocrineThyroidDiagramKey: "endocrine-thyroid-key",
  MethylationBh4CycleDiagramKey: "methylation-bh4-cycle-key",
  MethylationDetoxificationIntermediaryDiagramKey: "methylation-detoxification-intermediary-key",
  MethylationDetoxificationOverviewDiagramKey: "methylation-detoxification-overview-key",
  MethylationDetoxificationPhase1DiagramKey: "methylation-detoxification-phase1-key",
  MethylationDetoxificationPhase2DiagramKey: "methylation-detoxification-phase2-key",
  MethylationFolateDiagramKey: "methylation-folate-key",
  MethylationMethionineDiagramKey: "methylation-methionine-key",
  MethylationMethylationDiagramKey: "methylation-methylation-key",
  MethylationNitricOxideDiagramKey: "methylation-nitric-oxide-key",
  MethylationTranssulphurationDiagramKey: "methylation-transsulphuration-key",
  NutritionFolateDiagramKey: "nutrition-folate-key",
  NutritionIodineDiagramKey: "nutrition-iodine-key",
  NutritionIronOverloadDiagramKey: "nutrition-iron-overload-key",
  NutritionOmega3DiagramKey: "nutrition-omega3-key",
  NutritionSodiumPotassiumDiagramKey: "nutrition-sodium-potassium-key",
  NutritionVitaminADiagramKey: "nutrition-vitamin-a-key",
  NutritionVitaminB12DiagramKey: "nutrition-vitamin-b12-key",
  NutritionVitaminDDiagramKey: "nutrition-vitamin-d-key",
  NutritionZincDiagramKey: "nutrition-zinc-key"
};

export default DIAGRAM_KEY_CONTROLS_IDS;
